import React from 'react';
import { Form } from 'react-form';
import PropTypes from 'prop-types';

import { CheckBox } from '../../../components/Form';

import styles from '../nuoV2.scss';
import { NewUserOnboardingIDs } from '../../../components/Analytics/testIDConfig';

const SportTypeForm = (props) => {
    const { onSubmit, defaultValues, error, isFeedPreferenceModal, auth } = props;
    const feedPreferenceModalMessage = 'This will customize the content you see when logged into UTR Sports. You can update this anytime in settings.';
    const nonModalMessage = 'Your selection(s) customize the content you see. You can always update your sport preferences in settings later.';

    return (
        <Form
            onSubmit={values => onSubmit({ ...values })}
            defaultValues={defaultValues}
        >
            {(formApi) => {
                const { submitForm } = formApi;
                const testidPrefix = isFeedPreferenceModal ? 'modal.feed-preference' : 'nuo-v2.sport-type';
                return (
                    <form onSubmit={submitForm} data-testid={`${testidPrefix}.form`}>
                        <div className={`form-group ${styles.radioGroup} row`}>
                            <div className={`${isFeedPreferenceModal ? '' : 'col-12'}`}>
                                <div className={`${styles.description} ${isFeedPreferenceModal ? styles.modalDescription : ''}`} data-testid={`${testidPrefix}.description`}>
                                    {isFeedPreferenceModal ? feedPreferenceModalMessage : nonModalMessage}
                                </div>
                            </div>
                            {!isFeedPreferenceModal && (
                                <>
                                    <div className="col-12">
                                        <CheckBox
                                            id="tennis"
                                            customLabel="Tennis"
                                            field="tennis"
                                            formGroupCssClass="mb8"
                                            data-testid={`${NewUserOnboardingIDs.SportTypeTennis.component}-${NewUserOnboardingIDs.SportTypeTennis.location}-${NewUserOnboardingIDs.SportTypeTennis.id}`}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <CheckBox
                                            id="pickleball"
                                            customLabel="Pickleball"
                                            field="pickleball"
                                            formGroupCssClass="mb8"
                                            data-testid={`${NewUserOnboardingIDs.SportTypePickleball.component}-${NewUserOnboardingIDs.SportTypePickleball.location}-${NewUserOnboardingIDs.SportTypePickleball.id}`}
                                        />
                                    </div>
                                </>
                            )}

                            {!!isFeedPreferenceModal && (
                                <div className={`${styles.sportTypeMainContainer}`}>
                                    <div className={` col-12 ${styles.sportTypeContainer}`} data-testid="modal.feed-preference.pickleball-container">
                                        <div className={` ${styles.sportTypeDetails}`}>
                                            <img src="/img/icons/pickleball_icon_with_color.svg" alt="" data-testid="modal.feed-preference.pickleball-icon" />
                                            <p data-testid="modal.feed-preference.pickleball-label">Pickleball</p>
                                        </div>
                                        <CheckBox
                                            isFeedPreferenceModal={isFeedPreferenceModal}
                                            id="pickleball"
                                            customLabel="Pickleball"
                                            field="pickleball"
                                            formGroupCssClass="mb0"
                                            auth={auth}
                                            data-testid={`${NewUserOnboardingIDs.SportTypePickleball.component}-${NewUserOnboardingIDs.SportTypePickleball.location}-${NewUserOnboardingIDs.SportTypePickleball.id}`}
                                        />
                                    </div>
                                    <div className={` col-12 ${styles.sportTypeContainer}`} data-testid="modal.feed-preference.tennis-container">
                                        <div className={` ${styles.sportTypeDetails}`}>
                                            <img src="/img/icons/tennis_icon_with_color.svg" alt="" data-testid="modal.feed-preference.tennis-icon" />
                                            <p data-testid="modal.feed-preference.tennis-label">Tennis</p>
                                        </div>

                                        <CheckBox
                                            isFeedPreferenceModal={isFeedPreferenceModal}

                                            id="tennis"
                                            customLabel="Tennis"
                                            field="tennis"
                                            formGroupCssClass="mb0"
                                            auth={auth}
                                            data-testid={`${NewUserOnboardingIDs.SportTypeTennis.component}-${NewUserOnboardingIDs.SportTypeTennis.location}-${NewUserOnboardingIDs.SportTypeTennis.id}`}
                                        />
                                    </div>

                                </div>
                            )}
                            {error && (
                                <div className="col-12">
                                    <span className="error-text" data-testid={`${testidPrefix}.error`}>{error}</span>
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <div className={`form-group col-12 mb0 ${isFeedPreferenceModal ? 'pr0 pl0' : ''} `}>
                                <button
                                    type="submit"
                                    className={`btn btn-primary btn-xl btn-block text-uppercase ${styles.btn} ${isFeedPreferenceModal ? 'pr0 pl0' : ''}`}
                                    data-testid={`${NewUserOnboardingIDs.SportTypeContinueButton.component}-${NewUserOnboardingIDs.SportTypeContinueButton.location}-${NewUserOnboardingIDs.SportTypeContinueButton.id}`}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

SportTypeForm.propTypes = {
    isFeedPreferenceModal: PropTypes.bool.isRequired,
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default SportTypeForm;
